module.exports = __webpack_public_path__ + "static/media/ios-camera.ca4e94fa.svg";